var sliders = document.querySelectorAll('.js-flip-cards-slider');

sliders.forEach(function (slider, index) {
  let uniqueClass = 'js-flip-cards-slider-index-' + (index + 1);
  slider.classList.add(uniqueClass);

  // Initialize Swiper using the unique class
  new Swiper('.' + uniqueClass, {
    loop: false,
    slidesPerView: 'auto',
     mousewheel: {
      forceToAxis: true,
      sensitivity: 3
    },
    freeMode: true,
    spaceBetween: 16,
    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev'),
    },
  });
});
